var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 100,
    viewBox: "0 0 112 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.8,
    d: "M95.36 31.0417L99.085 49.6667H12.665L16.39 31.0417H95.36ZM105.542 0H6.20833V12.4167H105.542V0ZM105.542 18.625H6.20833L0 49.6667V62.0833H6.20833V99.3333H68.2917V62.0833H93.125V99.3333H105.542V62.0833H111.75V49.6667L105.542 18.625ZM18.625 86.9167V62.0833H55.875V86.9167H18.625Z",
    fill: "#707ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirm);
export default __webpack_public_path__ + "static/media/firm.0e98d8b0de7364a268eaca5e126143b2.svg";
export { ForwardRef as ReactComponent };